import React from "react";
import Card from "canvas-core-react/lib/Card";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom/cjs/react-router-dom";
import PendingAccountIcon from "../../../../static/images/MyActivity.svg";

const relations = {
  pathname: "relations",
  state: { activeTab: 1 },
};

const PendingAccountsAlert = () => {
  const { t } = useTranslation();

  return (
    <Card className="pending-accounts">
      <img src={PendingAccountIcon} />
      <p className="text-center mb-4 mt-2">
        {t("providers.pending_accounts_alert.new_pending_account")}
      </p>
      <Link to={relations}>
        <span className="approve-btn">
          {t("providers.pending_accounts_alert.approve")}
        </span>
      </Link>
    </Card>
  );
};

export default PendingAccountsAlert;
